import * as yup from 'yup';

export const CreateClassroomTypeFormValidation = yup.object().shape({
    description: yup.string().required('Nome do tipo de sala é obrigatório')
});